<template>
  <CopyTrackWrapper
    type="presentlevel"
    :uuid="uuid">
    <PresentLevelsConclusionTabs
      :student-name="studentName"
    />
    <div
      role="tabpanel"
      :id="$route.name + 'TabPanel'"
      :aria-labelledby="$route.name + 'Tab'"
    >
      <router-view
        :present-level-statement="presentLevelStatement"
        :student-name="studentName"
        :student-uuid="studentUuid"
        :enrolled-grade="enrolledGrade"
        :selected-subjects="selectedSubjects"
      />
    </div>
  </CopyTrackWrapper>
</template>

<script>
import { getPresentLevelStudentStatementDraft } from '@/api/presentlevels'
import CopyTrackWrapper from '@/components/CopyTrackWrapper'
import PresentLevelsConclusionTabs from '@/components/presentlevels/PresentLevelsConclusionTabs'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { authorizationCheckMixin } from '@/router/authorization_mixin'
import { blockPlwMixin } from '@/components/presentlevels/block_plw_mixin'

export default {
  name: 'PresentlevelsConclusion',
  components: {
    CopyTrackWrapper,
    PresentLevelsConclusionTabs,
  },
  mixins: [authorizationCheckMixin, blockPlwMixin],
  props: {
    uuid: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      presentLevelStatement: '',
      studentName: '',
      studentUuid: '',
      enrolledGrade: '',
      selectedSubjects: [],
      statementsByArea: {},
    }
  },
  async created() {
    try {
      let draftParams = {};
      if (this.iodVisibility || this.effectsVisibility) {
        draftParams = { includeImpacts: 'true'}
      } else {
        draftParams = { noIOD: 'true'}
      }
      if (this.effectsVisibility) {
        draftParams.effects = 'true'
      }
      let data = await getPresentLevelStudentStatementDraft(this.uuid, draftParams)
      await this.redirectIfUnauthorized(data.student.user_uuid, { name: 'PresentLevelsNewWizard' })

      this.studentName = data.student.student_name
      this.studentUuid = data.student.student_uuid
      this.presentLevelStatement = data.student.drafted_strengths
      this.enrolledGrade = data.student.enrolled_grade_level
      this.selectedSubjects = data.student.selected_subjects
      this.statementsByArea = data.student.statements_by_area
      this.setLastUpdate(data.student.updated_at)
      this.setBreadcrumbInfo({
        uuid: this.uuid,
        availableStages: this.selectedSubjects
      })
      this.setAreasOfNeed(this.selectedSubjects)

      let shortcutPayload = {
        name: data.student.student_name,
        subjects: data.student.selected_subjects,
        skillAreas: data.student.selected_skills,
        skillAreaGrades: data.student.selected_grades,
        enrolledGrade: data.student.enrolled_grade_level,
        categoryMapping: data.student.category_mappings,
        barrierMappings: data.student.barrier_mappings
      }
      this.setDraftedSkillsFromStatements(this.statementsByArea)
      this.setEnrolledGrade(data.student.enrolled_grade_level)
      this.setStudentName(data.student.student_name)
      this.setResourceDocs(data.student.resource_docs)
      this.generateGoalShortcutData(shortcutPayload)
      this.generateStrategyShortcutData(shortcutPayload)
      this.retrieveRelevantGoals({statementsByArea: data.student.statements_by_area, grade: data.student.enrolled_grade_level})
    } catch (err) {
      console.error(err)
    }
  },
  computed: {
    ...mapGetters('visibility',['iodVisibility', 'effectsVisibility']),
  },
  methods: {
    ...mapMutations('presentlevels', [
      'setBreadcrumbInfo',
      'setLastUpdate',
      'setEnrolledGrade',
      'setStudentName',
      'setAreasOfNeed',
      'setResourceDocs',
      'setDraftedSkillsFromStatements'
    ]),
    ...mapActions('presentlevels', ['generateGoalShortcutData', 'generateStrategyShortcutData', 'retrieveRelevantGoals']),
  },
}
</script>
